import React from 'react';
import PageWrapper from '../components/layout/PageWrapper';

/**
 * SPLICE建築企画建築設計ページコンポーネント
 * 未実装のため基本表記のみ
 */
const ArchiPage: React.FC = () => {
  return (
    <PageWrapper title="建築設計">
      <div className="text-center py-5">
        <p className="zen-old-mincho-regular text-muted">
          建築設計ページは準備中です。
        </p>
      </div>
    </PageWrapper>
  );
};

export default ArchiPage; 